import { restaurantsArrayPropTypes, selectedLocationPropTypes } from '@nandosaus/prop-types';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { ORDER_TYPES } from '@nandosaus/constants';
import { Flex } from '../grid';
import { Icon } from '../icons';
import { P } from '../typography/new';
import { RestaurantListItem } from './restaurant-list-item';
import getRestaurantPath from '../../utils/get-restaurant-path';

const RestaurantsList = ({ orderType, coordinates, onRestaurantClick, restaurants, variant, showRestaurantStatus }) => {
  return (
    <>
      {restaurants.map(restaurant => {
        const isButtonVariant = variant === 'button';
        // what is the orderType when nothing has been saved
        const isDisabled = !restaurant?.getIsAcceptingOrders({ orderType }) || false;

        const content = (
          <>
            <Flex
              width="100%"
              gap="8px"
              pt="16px"
              pb="20px"
              pl={variant === 'card' && { xs: '12px', lg: '18px' }}
              borderBottom={variant === 'button' && '1px solid'}
              borderColor={variant === 'button' && 'warmWhite3'}
            >
              <Icon name="barci" opacity={isButtonVariant && isDisabled ? 0.5 : 1} />
              <Flex flex="1 1 0">
                <RestaurantListItem
                  coordinates={coordinates}
                  onRestaurantClick={onRestaurantClick}
                  restaurant={restaurant}
                  showRestaurantStatus={showRestaurantStatus}
                />
              </Flex>
              {coordinates && (
                <P as="span" variant="extra-small" display="block" color="grey70">
                  {restaurant.formattedDistanceToRestaurant(coordinates)}
                </P>
              )}
            </Flex>
          </>
        );

        if (onRestaurantClick) {
          return (
            <ListItem
              as="button"
              variant={variant}
              disabled={isDisabled}
              onClick={() => onRestaurantClick(restaurant)}
              key={restaurant.name}
            >
              {content}
            </ListItem>
          );
        }

        return (
          <Link href={`${getRestaurantPath(restaurant)}`} passHref legacyBehavior key={restaurant.name}>
            <ListItem as="a" variant={variant}>
              {content}
            </ListItem>
          </Link>
        );
      })}
    </>
  );
};

const ListItem = styled.div`
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ variant }) => (variant === 'button' ? null : 'white')};
  display: flex;
  text-align: left;
  width: 100%;
  text-decoration: none;
  border: solid 1px transparent;

  &:disabled {
    color: ${({ theme }) => theme.colors.grey500};
  }

  ${({ variant }) =>
    variant === 'card' &&
    css`
      padding: 0.5rem 0rem;
      color: ${({ theme }) => theme.colors.black};
      padding-right: 1rem;
      :not(:last-child) {
        margin-bottom: 0.5rem;
      }
    `};
`;

RestaurantsList.propTypes = {
  coordinates: selectedLocationPropTypes,
  onRestaurantClick: PropTypes.func.isRequired,
  restaurants: restaurantsArrayPropTypes.isRequired,
  variant: PropTypes.oneOf(['button', 'card']),
  showRestaurantStatus: PropTypes.bool,
  orderType: PropTypes.oneOf([
    ORDER_TYPES.PICK_UP,
    ORDER_TYPES.DINE_IN,
    ORDER_TYPES.DELIVERY,
    ORDER_TYPES.CATERING,
    ORDER_TYPES.CATERING_DELIVERY,
  ]).isRequired,
};

RestaurantsList.defaultProps = {
  coordinates: undefined,
  showRestaurantStatus: false,
  variant: 'button',
};

export { RestaurantsList };
